import { render, staticRenderFns } from "./WorkflowRequestHistory.vue?vue&type=template&id=77f9cab6"
import script from "./WorkflowRequestHistory.vue?vue&type=script&lang=js"
export * from "./WorkflowRequestHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports